import LinkPage from 'components/_UI/LinkPage';
import Text from 'components/_UI/Text';
import DynamicProfileBackground from 'components/commons/DynamicProfileBackground';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import types from 'helpers/system/types';
import { MapPin } from 'lucide-react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import eventTypes from 'theme/eventTypes';
import fonts from 'theme/fonts';
import { useNavigate } from "react-router-dom";
import indexPriority from 'theme/z-index';
import Icon from 'components/_UI/Icon';



export default function EstablishmentPageCover({ establishment }) {
   const navigate = useNavigate();
    function backSector() {
        navigate(-1)
    }
    return (
        <Container>
            <ProfileContainer>
                <ContentThumb>
                    <BackButton onClick={() => backSector ()}>
                         <Icon name='back' color={colors.night} />
                    </BackButton>
                    <DynamicProfileBackground
                        img={establishment?.backgroundImage.path}
                        size={'118px'}
                    />
                    <CardImage status={establishment?.open}>
                        <DynamicProfileImage
                            img={establishment?.profileImage?.path}
                            size={'80px'}
                            word={establishment?.name}
                        />
                    </CardImage>
                </ContentThumb>
            </ProfileContainer>


            <CardMainContent>
                <Text
                    color={colors.nightDark}
                    name='subtitle'
                    type='bold'
                    paddingTop={'12px'}
                    paddingBottom={'6px'}
                >
                    {establishment?.name}
                </Text>
                <CategoriesContainer>

                    {
                      establishment?.tagsEstablishments?.map((tag) => (
                        <Category type='tag' key={tag}>
                          <Text name='mini' color={colors.neutral} paddingBottom={0} >
                            {tag?.name}
                          </Text>
                        </Category>

                      ))
                    }
                </CategoriesContainer>
            </CardMainContent >



        </Container>
    )
}


const Container = styled(Column)`

`;

const BluredBackground = styled.div`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}){
        display: flex;
        width: 200%;
        height: calc(100% + 30px);
        position: absolute;
        left: -10%;
        top: -2%;
        background-image: url(${props => props.src});
        background-size: cover;
        background-position: center;
        filter: blur(10px);
        z-index: -1;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: ${colors.nightDark};
            opacity: .75;
        }
    }
`;


const StyledBackground = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 0 0 18px 18px;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 85%;
        height: 280px;
        border-radius: 12px;
        box-shadow: none;
    }
`;

const ImageContainer = styled.div`
    width: 100%;
    height: auto;
    position: relative;

    @media screen and (min-width: ${breakpoints.lg}){
    }
`;


const CategoriesInfos = styled(Row)`
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 15px;

    & > p {
        padding-bottom: 0;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        margin-bottom: 5px;
        justify-content: flex-start;
    }

`;

const CardMainContent = styled(Column)`
    padding: 16px 6%;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 30px;


`

const EventType = styled.div`
    color: ${colors.neutralLight};
    border-radius: 6px;
    padding: 4px 10px;
    font-size: ${fonts.sizes.small};
    text-transform: capitalize;

    ${({ type }) => type === eventTypes.free.slug && `
        background: ${eventTypes.free.color};
    `}

    ${({ type }) => type === eventTypes.paid.slug && `
        background: ${eventTypes.paid.color};
    `}
`;


const Tag = styled(FullyCentered)`
    padding: 4px 8px;
    border-radius: 6px;
    background: ${colors.goldLight};
    width: auto;
    margin-left: 4px;

    ${({ adulthood }) => adulthood && `
        background: ${colors.nightDark};
    `};

    & > p {
        padding-bottom: 0 !important;
        text-transform: capitalize !important;
    }
`;

const ContentInfoRow = styled(Row)`
    margin-bottom: 10px;
    align-items: flex-start;
    text-align: left;

    ${({ address }) => address && `
        align-items: center;
    `}

    ${({ single }) => single && `
        align-items: center;

        & > p {
            padding-bottom: 0 !important;
        }
    `}

    &:nth-child(3){
        margin-bottom: 0;
    }

    & > p {
        padding: 0;
        margin: 0;
    }

    & > a > p{
        padding-bottom: 0 !important;
    }
`;

const ContentLinkAddress = styled.div`
    width: auto;
`;

const ProfileContainer = styled(Column)`
  width: 100%;
  flex-wrap: wrap;

`;

const ContentThumb = styled.div`
  display:flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  `;

const CardImage = styled.div`
  width: 78px;
  height: 78px;
  position: absolute;
  bottom: -35px;
  border-radius: 50%;

  &:after{
    content: '';
    border: 3px solid ${colors.neutral};
    position: absolute;
    bottom: -4px;
    left: -2px;
    width: 78px;
    height: 78px;
    border-radius: 50%;
    }

  & > picture > img {
    object-fit: cover;
  }
`;

const Category = styled(FullyCentered)`
  color: ${colors.night};
  background-color: ${colors.occasionalPurple};
  border-radius: 30px;
  width: auto;
  padding: 4px 6px;
  margin-top: 4px;
  margin-right: 6px;

  ${({ type }) => type === 'tag' && `
    background-color: ${colors.occasionalOrange};
  `}

  & > p {
    width: auto;
    text-transform: capitalize;
  }
`
const CategoriesContainer = styled(Row)`
  flex-wrap: wrap;
  justify-content: center;
`;


const BackButton = styled.div`
    position: absolute;
    left: 5px;
    width: 30px;
    height: 30px;
    padding: 6px;
    top: 5px;
    border-radius: 30px;
    background: ${colors.neutralLight};
    border: 1px solid ${colors.nightLight};
    box-shadow: 1px 4x 4px ${colors.night};
    transition: all ease .3s;
    z-index: ${indexPriority.xHigh};
    cursor: pointer;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }



`;
